import httpClient from '@/api/httpClient';

const fetchStrategy = investmentHorizon => {
    return httpClient.get('investment-strategy/search', {
        params: {
            investmentHorizon,
        },
    }).then(({ data }) => {
        return data;
    });
};

const fetchStrategyByType = (investmentStrategyType, language) => {
    return httpClient.get(`/investment-strategy/${investmentStrategyType.name}/${language.toUpperCase()}`)
        .then(({ data }) => {
            return data;
        });
};

export default {
    fetchStrategy,
    fetchStrategyByType,
};
